import * as React from 'react';
import { SVGProps } from 'react';

const SettlementsSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 32 32'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path fill='#9395A1' d='M4 12h24L16 4 4 12Z' opacity={0.2} />
    <path
      stroke='#9395A1'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M4 12h24L16 4 4 12ZM7 12v10M13 12v10M19 12v10M25 12v10M4 22h24M2 26h28'
    />
  </svg>
);

export default SettlementsSidebar;
